// extracted by mini-css-extract-plugin
module.exports = {"screen-lg":"992px","social-links":"style_social-links__6fDR1","flex-content":"style_flex-content__jrohv"};